import { render, staticRenderFns } from "./shipperDetail.vue?vue&type=template&id=3159fcb8&scoped=true"
import script from "./shipperDetail.vue?vue&type=script&lang=js"
export * from "./shipperDetail.vue?vue&type=script&lang=js"
import style0 from "./shipperDetail.vue?vue&type=style&index=0&id=3159fcb8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3159fcb8",
  null
  
)

export default component.exports